import { memo } from 'react';
import { BzCard, BzChip, BzHeading } from '../../../components';
import { Container, Row, Col } from 'react-bootstrap';

const MyNotes = ({ arrMyNotes }) => {
    return (
        <Container fluid className='px-3'>
            {arrMyNotes.map((each, i) => (
                <BzCard className='p-0 py-3 bdr-btm' key={i}>
                    <Row className='g-0 mb-1'>
                        <Col>
                            <BzHeading className='font-medium font-size3 color-text'>{each.title}</BzHeading>
                        </Col>
                    </Row>
                    <Row className='g-0 mb-3'>
                        <Col>
                            <div className='font-regular font-size3 color-text'>{each.description}</div>
                        </Col>
                    </Row>
                    <Row className='g-0'>
                        <Col md={7} className='d-flex justify-content-start align-self-start'>
                            <div className='chips-wrap'>
                                <BzChip className='chips primary-chip text-uppercase me-2 mb-2'>{each.categoryName}</BzChip>
                                <BzChip className='chips primary-chip text-uppercase mb-2'>{each.subCategory}</BzChip>
                            </div>
                        </Col>
                        <Col md={5} className='d-flex justify-content-end align-self-start'>
                            <div className='font-regular font-size1 color-subtext'>{each.issueDate}</div>
                        </Col>
                    </Row>
                </BzCard>
            ))}
        </Container>
    );
};

export default memo(MyNotes);